import React, { useEffect, useState, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import Button from '../../../../../../elements/button'
import CommonInputText from '../../../../../../components/commonInputText'
import { Controller, useFieldArray, useForm } from 'react-hook-form'
import { useParams } from 'react-router-dom'
import DOMPurify from 'dompurify'
import Text from '../../../../../../elements/Typo/Text'
import CustomAgGrid from '../../../../../../components/CustomAgGrid'
import { useExperimentApi } from '../../../../../../store/api/hooks/experimentApiHook'
import toast from 'react-hot-toast'
import { useExperimentSelector } from '../../../../../../store/selectors/experimentSelector'
import { AgGridReact } from 'ag-grid-react'
import { useFpLoader } from '../../../../../../store/api/hooks/fpLoaderHook'
import Dropdown from '../../../../../../elements/Form/dropdown'
import { useDialog } from '../../../../../../store/api/hooks/dialogHook'
import { SelectedDataTableType } from '../../../../../../_config/types'
import { makeUniqueOptionArray } from '../../../../../../_common/functions'
import MeasurementSuccessModal from '../../../../../Measurement/MeasurementConfigure/modal/measurementSuccess.modal'
import Loader from '../../../../../../components/loader'
import FieldValidation from '../../../../../../components/groupConfigComponents/fieldValidation'
import { DateFrequency } from '../../../../../Measurement/MeasurementConfigure'
import i18n from '../../../../../../i18n'

interface MeasurementDataModalProps {
    _ref: any
    tabledata: SelectedDataTableType
    literal: string
    onPrevious: () => void
    getKpiTypes: any
    getColumns: any
}

const RCTMeasurementDataModal: React.FC<MeasurementDataModalProps> = ({ _ref, getKpiTypes, getColumns, tabledata, literal, onPrevious = () => {} }) => {
    const { t } = useTranslation()
    const params: any = useParams()
    const dataTableGrid = useRef<AgGridReact>(null)
    const experiment = useExperimentSelector()
    const experimentApi = useExperimentApi()
    const [rowData, setRowData] = useState<[]>([])
    const [columnDefs, setcolumnDefs] = useState<[]>([])
    const { showLoader, hideLoader } = useFpLoader()
    const [columns, setColumns] = useState<any>(null)
    const [kpiInterests, setKpiInterests] = useState<any[]>([])
    const [cols, setCols] = useState<any>(null)
    const [mdata, setMdata] = useState<any>(null)
    const measurementSuccessModalRef: any = useRef()
    const [working, setWorking] = useState<boolean>(false)

    const [kpiColumns, setKpiColumns] = useState<any[]>([])

    const dialog = useDialog()

    const {
        control,
        getValues,
        trigger,
        formState: { errors, isValid },
    } = useForm()

    const {
        fields: metricFields,
        append: metricAppend,
        remove: metricRemove,
    } = useFieldArray({
        control,
        name: 'metrics',
    })

    const getTableData = (datacountry: any[] = []) => {
        showLoader()
        experimentApi.getmeasurementdata(
            {
                query: '',
                table_name: tabledata.table.name,
                page: 1,
                per_page: 10,
            },
            (data: any) => {
                hideLoader()

                const columnDefs: any = Object.keys(data?.data?.result[0] || {}).map((key: any, i: number) => {
                    return {
                        headerName: key,
                        field: key,
                        filter: false,
                        sortable: false,
                        suppressMenu: true,
                    }
                })
                setcolumnDefs(columnDefs)
                setRowData(data?.data?.result)
            },
            (error: any) => {
                hideLoader()
            },
        )
    }

    const updateExperiment = () => {
        const DATA: any = getValues()
        const payload: any = {
            literal,
            measurement_column_map: {
                granularity: DATA._name1.value,
                date: DATA._name2.value,
                allocation_group: DATA._name3?.value ?? 'ex_factor_1',
                date_frequency: DATA.frequency,
                kpi: DATA.metrics.map((kpi: any) => {
                    const kpidata = {
                        ...kpi,
                        column_map: kpi.column_map.value,
                    }
                    delete kpidata.id
                    return kpidata
                }),
            },
            submit_from: 'measurement_configuration',
        }

        setWorking(true)

        experimentApi.updateExperiment(
            payload,
            (data: any) => {
                experimentApi.executedesignmergeoverview(
                    { literal: params.experiment },
                    (resp: any) => {
                        setWorking(false)
                        setMdata(resp)
                        measurementSuccessModalRef?.current?.showModal()
                    },
                    (error: any) => {
                        setWorking(false)
                    },
                )
            },
            (error: any) => {
                setWorking(false)
                toast.error(error?.message)
            },
        )
    }

    useEffect(() => {
        if (experiment?.experiment_metadatas?.metrices) {
            metricRemove()
            experiment?.experiment_metadatas?.metrices.map((kpi: any) => {
                metricAppend(kpi)
            })

            setKpiColumns(
                experiment?.experiment_metadatas?.metrices.map((kpi: any) => {
                    return kpi.literral_value.toLowerCase()
                }),
            )
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [experiment])

    useEffect(() => {
        if (tabledata && experiment?.data_mappings?.delta_measurement_table_name) {
            getKpiTypes().then(setKpiInterests)
            getColumns()
                .then((data: any) => {
                    setCols(data.cols)
                    setColumns(data.columns)
                })
                .catch((error) => {
                    console.error('Error :', error)
                })
            getTableData()
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [tabledata, experiment])

    const isDefaultKPI = (kpi: string) => {
        const found: any = kpiInterests.filter((metrix: any) => {
            return metrix.name?.toLowerCase() == kpi.toLowerCase()
        })
        return found.length > 0
    }

    const columnMapOnchange = (value: any, kpi: any, onChange: any, i: any) => {
        if (isDefaultKPI(kpi.literral_value)) {
            if (kpi.literral_value.toLowerCase() != value.label.toLowerCase() && columns.numeric_columns.map((col: any) => col.label.toLowerCase()).includes(kpi.literral_value.toLowerCase())) {
                //warning --
                dialog.confirm({
                    type: 'delete',
                    title: t('Warning: Mismatch Identified'),
                    message: `You have mapped <b>${DOMPurify.sanitize(value.label)}</b> for KPI <b>${DOMPurify.sanitize(kpi.literral_value)}</b>, We found <b>${DOMPurify.sanitize(kpi.literral_value)}</b> another column which could be more relavent.`,
                    warning: t('The results might become inaccurate if you proceed this way'),
                    confirmButtonLabel: t('Yes Proceed'),
                    onConfirm: () => {
                        onChange(value)
                        void trigger(`metrics.${i}`)
                    },
                })
            } else if (kpiColumns.filter((_kpi: any) => _kpi != kpi.literral_value.toLowerCase()).includes(value.label.toLowerCase())) {
                dialog.confirm({
                    type: 'delete',
                    title: t('Warning: Mismatch Identified'),
                    message: `You have mapped <b>${DOMPurify.sanitize(value.label)}</b> for KPI <b>${DOMPurify.sanitize(kpi.literral_value)}</b>, We found <b>${DOMPurify.sanitize(value.label)}</b> could be more relavent with KPI <b>${DOMPurify.sanitize(value.label)}</b>.`,
                    warning: t('The results might become inaccurate if you proceed this way'),
                    confirmButtonLabel: t('Yes Proceed'),
                    onConfirm: () => {
                        onChange(value)
                        void trigger(`metrics.${i}`)
                    },
                })
            } else {
                onChange(value)
                void trigger(`metrics.${i}`)
            }
        } else {
            onChange(value)
            void trigger(`metrics.${i}`)
        }
    }
    return (
        <dialog ref={_ref} className="modal" data-testid="measurement-data-modal">
            <div className="modal-box w-11/12 max-w-5xl">
                <p className="font-bold text-start text-[1.125rem] leading-8" data-testid="modal-title">
                    {t('Measurement Data')}
                </p>
                <Text size="md" className="mt-2" data-testid="modal-description">
                    {t('Map your data')}
                </Text>

                <div className="grid grid-cols-3 gap-3">
                    <div>
                        <Text size="md" className="text-black font-medium">
                            {t('Select Granularity')}
                        </Text>
                        <Text size="md" className="text-[#464E5F] mb-2 italic">
                            {t('Please select the column which represents the Granularity')} <span className="text-red-500">*</span>
                        </Text>
                    </div>

                    <div>
                        <Text size="md" className="text-black font-medium">
                            {t('Select Grouping Column')}
                        </Text>
                        <Text size="md" className="text-[#464E5F] mb-2">
                            {t('Select the column that maps Test and Control groups at the chosen granularity.')}
                        </Text>
                    </div>

                    <div>
                        <Text size="md" className="text-black font-medium">
                            {t('Select Date')}
                        </Text>
                        <Text size="md" className="text-[#464E5F] mb-2">
                            {t('Please select the column which represents the date')} <span className="text-red-500">*</span>
                        </Text>
                    </div>
                </div>
                <div className="grid grid-cols-3 gap-3">
                    <div>
                        <Controller
                            name="_name1"
                            control={control}
                            rules={{ required: t('Please select') }}
                            render={({ field: { value, onChange } }) => (
                                <Dropdown
                                    value={value}
                                    onChange={(value: any) => {
                                        onChange(value)
                                        void trigger('_name1')
                                    }}
                                    options={columns?.unique_columns ?? []}
                                    error={errors?._name1?.message as string}
                                />
                            )}
                        />

                        <FieldValidation />
                    </div>

                    <div>
                        <Controller
                            name="_name3"
                            control={control}
                            render={({ field: { value, onChange } }) => (
                                <Dropdown
                                    value={value}
                                    isClearable
                                    onChange={(value: any) => {
                                        onChange(value)
                                        void trigger('_name3')
                                    }}
                                    options={columns ? makeUniqueOptionArray([...columns.string_columns]) : []}
                                    error={errors?._name2?.message as string}
                                />
                            )}
                        />

                        <FieldValidation />
                    </div>

                    <div>
                        <Controller
                            name="_name2"
                            control={control}
                            rules={{ required: t('Please select') }}
                            render={({ field: { value, onChange } }) => (
                                <Dropdown
                                    value={value}
                                    onChange={(value: any) => {
                                        onChange(value)
                                        void trigger('_name2')
                                    }}
                                    options={cols ?? []}
                                    error={errors?._name2?.message as string}
                                />
                            )}
                        />

                        <div className="bg-[#FAF8EF] border border-[#0AD4E133] rounded-[0.45rem] mt-2">
                            <Text size="lg" className="font-semibold p-2">
                                {t('Validation:')} {t('No Missing Values')}
                            </Text>
                            <div className="border-b border-[#0AD4E133]"></div>
                            <div className="flex items-center justify-between p-1">
                                {metricFields?.length && (metricFields[0] as any).literral_value != 'Total Distribution' ? (
                                    <>
                                        <Text size="md" className="!leading-none">
                                            {t('Select Time Granularity')}
                                        </Text>
                                        {DateFrequency(control, trigger, metricFields, t)}
                                    </>
                                ) : (
                                    <div className="h-6"></div>
                                )}
                            </div>
                            <div className="flex justify-end">{errors?.frequency?.message ? <p className="text-error text-[.542rem] mt-1">{errors?.frequency?.message as string}</p> : null}</div>
                        </div>
                    </div>
                </div>

                <div className="mt-4 grid grid-cols-2 gap-3">
                    <div>
                        <div>
                            <Text size="md" className="text-black font-medium">
                                {t('Select KPIs Column')}
                            </Text>
                            <Text size="md" className="text-[#464E5F] mb-2 italic">
                                {t('The columns which represent the primary and other KPIs on which you want to execute Measurement. Please ensure to select the relevant numerical columns only.')} <span className="text-red-500">*</span>
                            </Text>
                        </div>

                        {kpiInterests && (
                            <>
                                {metricFields.map((kpi: any, i: number) => (
                                    <div key={`kpi-${kpi.literral_value}`} className="grid grid-cols-2 gap-2 mb-2">
                                        <CommonInputText value={kpi.literral_value} disabled={true} />
                                        <Controller
                                            name={`metrics.${i}.column_map`}
                                            control={control}
                                            rules={{
                                                required: t('Please select'),
                                            }}
                                            render={({ field: { value, onChange } }) => (
                                                <Dropdown
                                                    value={value}
                                                    onChange={(value: any) => {
                                                        columnMapOnchange(value, kpi, onChange, i)
                                                    }}
                                                    options={columns?.numeric_columns ?? []}
                                                    error={(errors?.metrics as any)?.[i]?.column_map?.message as string}
                                                />
                                            )}
                                        />
                                    </div>
                                ))}
                            </>
                        )}
                    </div>
                </div>

                <div className="my-4">
                    <CustomAgGrid
                        key={'mmData' + i18n.language}
                        gridRef={dataTableGrid}
                        rowData={rowData}
                        columnDefs={columnDefs}
                        defaultColDef={{ sortable: true, filter: true }}
                        theme="light"
                        pagination={false}
                        paginationPageSize={5} // Must match one of the values below
                        paginationPageSizeSelector={[5, 10, 20, 50]} // Ensure 5 is included
                        style={{ height: 350, width: '100%' }}
                        gridId="summmyGrid"
                        rowHeight={50}
                        alternativeRowColor={'#E5B61112'}
                    />
                </div>
                <div className="flex justify-between gap-3 pt-4">
                    <div>
                        <Button theme="secondary" styleType="outline" size="xs" onClick={onPrevious}>
                            {t('Previous Step')}
                        </Button>
                    </div>
                    <div className="flex gap-3">
                        <Button
                            theme="secondary"
                            size="xs"
                            styleType="outline"
                            onClick={() => {
                                _ref?.current?.close()
                            }}
                            data-testid="cancel-button"
                        >
                            {t('Cancel')}
                        </Button>
                        <Button
                            theme="secondary"
                            size="xs"
                            onClick={() => {
                                if (experiment.is_measurement_triggered && !experiment.is_completed) {
                                    dialog.confirm({
                                        type: 'delete',
                                        title: t('Measurement In Progress'),
                                        message: t('Are you sure you want to re-submit this experiment? This action will overwrite the existing experiment.'),
                                        warning: t('This action cannot be undone.'),
                                        confirmButtonLabel: t('Yes Continue'),
                                        onConfirm: () => {
                                            void trigger()
                                            if (isValid) {
                                                updateExperiment()
                                            }
                                        },
                                        onCancel: () => {},
                                    })
                                } else if (experiment.is_completed) {
                                    dialog.confirm({
                                        type: 'delete',
                                        title: t('Complete Experiment'),
                                        message: t('Experiment has already been completed.'),
                                        warning: t('The user is informed that the experiment is no longer active for analysis.'),
                                        confirmButtonLabel: t('ok I Got It'),
                                        onConfirm: () => {},
                                    })
                                } else {
                                    void trigger()
                                    if (isValid) {
                                        updateExperiment()
                                    }
                                }
                            }}
                            data-testid="finalize-button"
                        >
                            {working ? <Loader /> : t('Finalize Measurement Data')}
                        </Button>
                    </div>
                </div>
            </div>
            <form method="dialog" className="modal-backdrop">
                <button type="button">{t('close')}</button>
            </form>
            <MeasurementSuccessModal _ref={measurementSuccessModalRef} mdata={mdata} updateExperiment={_ref} />
        </dialog>
    )
}

export default RCTMeasurementDataModal
